import { doXhr } from '../../../remote/request.js';
import AjaxEntity from './base.js';

/**
 * @typedef {{ content: string|null; } } SectionResponse
 * @typedef {{ data_content: { [key: string]: string|null; } }} MultiSectionResponse
 */

/**
 * @class Section
 */
export default class Section extends AjaxEntity {

	static get NAME() {
		return 'Section';
	}

	/**
	 * @param {string[]} ids
	 * @param {string=} url
	 * @param {any=} data
	 *
	 * @returns {Promise<MultiSectionResponse>}
	 */
	async load(ids, url = null, data = null, ignoreErrors = false) {

		const route = new URL(url || document.URL, window.location.origin);
		route.searchParams.append('sections', ids.join(','));
		const method = (data == null) ? 'GET' : 'POST';

		try {
			const response = await doXhr(route.toString(), { method, data, headers: { 'X-Remote-Signature': 'fragment' } });

			// Got redirect location
			if (response.location) {
				// Close everything
				mpro.closeAllOverlays();
				mpro.setLocation(response.location/* , { replace: true } */);
				return { data_content: {} };
			}

			return response;
		}
		catch (error) {

			// Show generic error message
			if (!ignoreErrors) {
				mpro.toast('error', mpro.langvar('error_unknown'));
			}

			throw error;
		}
	}

	/**
	 * @param {string[]} ids
	 * @param {string=} url
	 * @param {any=} data
	 *
	 * @returns {Promise<MultiSectionResponse>}
	 */
	reload(ids, url = null, data = null, ignoreErrors = false) {
		return this.load(ids, url, data, ignoreErrors);
	}
}
